import React, {
  useCallback,
} from 'react';
import {
  getStatus,
} from 'redux-resource';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';

import {
  getUiState,
} from 'web-selectors';

import {
  Assign,
  Spinner,
} from 'web-components';

interface Props {
  type: string
  templateId: number
}

const AssignContainer = ({
  type,
  templateId,
}: Props) => {
  const dispatch = useDispatch();

  const listName = `${type}_${templateId}`;
  const resourceType = type === 'program' ? 'personalPrograms' : 'personalWorkouts';
  const templateType = type === 'program' ? 'ProgramTemplate' : 'WorkoutTemplate';

  const mapState = useCallback(state => ({
    changeStatus: getStatus(
      state,
      [
        `${resourceType}.requests.assignClient.status`,
        `${resourceType}.requests.unAssignClient.status`,
        'groupAssignments.requests.assignGroup.status',
        'groupAssignments.requests.unAssignGroup.status',
      ],
      false,
    ),
    clientsMeta: coreSelectors.getRequestProperties(
      'clients',
      'fetchIndividuals',
    )(state).meta,
    openedTooltips: getUiState('openedTooltips')(state),
    profile: coreSelectors.getProfile(state),
    assignees: coreSelectors.getTemplateAssignees(
      listName,
    )(state),
  }), [templateId]);

  const {
    profile,
    assignees,
    clientsMeta,
    changeStatus,
    openedTooltips,
  } = useSelector(mapState, shallowEqual);

  const checkTooltips = () => {
    if (openedTooltips.some(el => el.key === 'choose_client')) {
      dispatch(
        uiActions.setUiState({
          openedTooltips: [],
        }),
      );
    }

    const steps = profile.user_settings.tutorial_steps;
    if (steps.includes('assign_workout')) return;
    dispatch(
      coreActions.requestMarkTutotialStepsComplite({
        steps: ['assign_workout'],
      }),
    );
  };

  const handleAssignClient = (item: any) => {
    checkTooltips();
    dispatch(
      coreActions.requestAssignClient({
        payload: {
          person_id: item.id,
          ...(type === 'program'
            ? {
              program_template_id: templateId,
            } : {
              workout_template_id: templateId,
            }
          ),
        },
        resourceType,
        listName,
      }),
    );
  };

  const handleUnAssignClient = (item: any) => {
    checkTooltips();
    dispatch(
      coreActions.requestUnAssignClient({
        id: item.id,
        resourceType,
      }),
    );
  };

  const handleAssignGroup = (item: any) => {
    dispatch(
      coreActions.requestAssignGroup({
        id: item.id,
        payload: {
          template_id: templateId,
          template_type: templateType,
        },
        listName,
      }),
    );
  };

  const handleUnAssignGroup = (item: any) => {
    const onConfirmAction = coreActions.requestUnAssignGroup({
      id: item.id,
      payload: {
        template_id: templateId,
        template_type: templateType,
      },
    });

    dispatch(
      uiActions.confirmModal({
        modal: {
          title: `Unassign ${templateType}?`,
          bodyText: `Are you sure you want unassign ${templateType} from group?`,
        },
        onConfirmAction,
      }),
    );
  };

  return (
    <>
      <Assign
        assignees={assignees}
        clientsMeta={clientsMeta}
        onAssignClient={handleAssignClient}
        onUnAssignClient={handleUnAssignClient}
        onAssignGroup={handleAssignGroup}
        onUnAssignGroup={handleUnAssignGroup}
        openedTooltips={openedTooltips}
      />

      {changeStatus.pending && (
        <Spinner over />
      )}
    </>
  );
};

export default AssignContainer;
